import React from 'react';
import type {ResponsiveValue, TableCellProps} from '@tempo/core';
import {Td as TempoTd, useBreakpointValue} from '@tempo/core';
import {useTableCellDisplayValue} from '../utils';
import {useTableStyles} from '../contexts/TableStyleContext';
import {useTableContext} from '@components/Table';

export type TdProps = {
	display?: ResponsiveValue<boolean>;
	colSpan?: number | 'full';
	sticky?: boolean;
} & Omit<TableCellProps, 'display' | 'colSpan'>;

const Td = ({display, className, colSpan, sticky, sx, ...props}: TdProps) => {
	const {columnCount} = useTableContext();
	const recipe = useTableStyles();
	const displayValue = useTableCellDisplayValue(display);
	const isVisible = useBreakpointValue(
		typeof display === 'undefined' ? true : display,
	);

	const visibilityKey = String(isVisible);

	return (
		<TempoTd
			key={visibilityKey}
			{...props}
			display={displayValue}
			className={
				isVisible
					? className
					: [className, 'hidden-cell'].filter(Boolean).join(' ')
			}
			colSpan={colSpan === 'full' ? columnCount : colSpan}
			sx={{
				...recipe.td,

				...(sticky
					? {
							position: 'sticky',
							left: 0,
							backgroundColor: 'background.neutral.primary.default',
							zIndex: 'docked',
						}
					: {}),

				...sx,
			}}
		/>
	);
};

export default Td;
